export const LAUNCH_TOAST = 'LAUNCH_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

export const LAUNCH_TOAST_CARD = 'LAUNCH_TOAST_CARD';
export const REMOVE_TOAST_CARD = 'REMOVE_TOAST_CARD';
